import React, { Component } from 'react';
import classes from "./ReportsPageTabs.module.css";
import SessionAttendanceTable from '../SessionAttendanceTable/SessionAttendanceTable';
import ResourceAPIController from '../../webServices/ResourceAPIController';
import { IsStringEmpty, IsObjectEmpty } from '../../utilities/CommonMethods';
import ProgressComponent from '../UI/ProgressComponent/ProgressComponent';
import ShowLoader from '../../hoc/ShowLoader/ShowLoader';

export default class InstructorAttendance extends Component {
    state = {
        reportData: { sessionsConducted: { label: '' }, totalSessionsScheduled: { label: '' }, daysMissed: '' },
        week: [],
        showLoader: true,
        isProgramManager: this.props.isProgramManager,
    }

    getInstructorAttendanceReport = () => {

        ResourceAPIController.getInstructorAttendanceReport(this.props.batchCode, this.props.moduleName)
            .then(response => {

                // console.log('getInstructorAttendanceReport Data => ', response.result);

                this.setState({
                    showLoader: false,
                    reportData: response.result.reportData,
                    week: response.result.week
                });

            })
            .catch(err => {
                console.log('getInstructorAttendanceReport error => ', err)
                this.setState({ showLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    componentDidMount() {
        const batchCode = this.props.batchCode, moduleName = this.props.moduleName;
        if (!IsStringEmpty(batchCode) && !IsStringEmpty(moduleName)) {
            this.getInstructorAttendanceReport();
        }
    }

    componentDidUpdate(prevProps) {
        // const batchCode = this.props.batchCode, moduleName = this.props.moduleName;
        if (prevProps.batchCode !== this.props.batchCode || prevProps.moduleName !== this.props.moduleName) {
            this.getInstructorAttendanceReport();
        }
    }

    render() {
        return (
            <div>
                {
                    this.state.showLoader
                        ? <div className={classes.LoaderContainer}><ShowLoader isLoading={true} /></div>
                        : <div className={classes.ReportsPageData}>
                            <div className={[classes.ReportsPageHeading, this.state.isProgramManager && classes.HeadingWithImg].join(' ')}>{this.state.isProgramManager && <span className={classes.ProfilePic}>
                                <img src={this.state.reportData.instructorProfilePic} alt="Instructor Profile Pic" width="80" className={classes.ProfilePic} />
                                <img src={this.state.reportData.moduleLogo} alt="Module logo" width="30" className={classes.ModuleLogo} />
                            </span>} {this.state.isProgramManager ? this.state.reportData.instructorName + "'s Attendance" : "Instructor Attendance Report"}</div>
                            <div className={classes.ReportsCard}>
                                <div className={classes.ReportsCardContainer}>
                                    <div className={classes.ProgressComponentDiv}>
                                        <ProgressComponent
                                            label="Sessions Conducted"
                                            type="Fraction"
                                            height="80px"
                                            fractionText={this.state.reportData.sessionsConducted.label}
                                            showProgressBar={false} />
                                    </div>

                                    <div className={classes.ProgressComponentDiv}>
                                        <ProgressComponent
                                            label="Sessions Scheduled"
                                            type="Fraction"
                                            height="80px"
                                            fractionText={this.state.reportData.totalSessionsScheduled.label}
                                            showProgressBar={false} />
                                    </div>

                                    <div className={classes.ProgressComponentDiv}>
                                        <ProgressComponent
                                            label="Days Missed"
                                            overallPercentage={this.state.reportData.daysMissed}
                                            showProgressBar={false}
                                            type="Value"
                                            height="80px"
                                            borderColor={this.state.reportData.daysMissed > 0 ? "red" : null} />
                                    </div>
                                </div>
                            </div>
                            <div className={classes.TableContainer}>
                                <div className={classes.LinkTextContainer} style={{ visibility: 'hidden' }}>
                                    <div className={classes.LinkText}>Download Report</div>
                                </div>
                                <SessionAttendanceTable
                                    data={this.state.week}
                                    reportData={this.state.reportData} />
                            </div>
                        </div>
                }
            </div>
        )
    }
}
